import { h } from 'preact'

const CREDITS_PER_USD = 10_000
const toCredits = (usd) => Math.round((usd || 0) * CREDITS_PER_USD).toLocaleString()

/**
 * CostBadge — displays message cost and budget remaining.
 * Props: { cost, i18n }
 * cost: { message_cost, budget_remaining, budget_limit, budget_exceeded }
 */
export function CostBadge({ cost, i18n }) {
  if (!cost) return null

  const msgCost   = typeof cost.message_cost    === 'number' ? cost.message_cost    : 0
  const remaining = typeof cost.budget_remaining === 'number' ? cost.budget_remaining : null
  const limit     = typeof cost.budget_limit     === 'number' ? cost.budget_limit     : 0
  const exceeded  = !!cost.budget_exceeded

  // Don't show the budget row if there is no configured limit (0 properties) or
  // the remaining value was not provided (older messages in history hydration).
  const showBudget = limit > 0 && remaining !== null

  const costLabel = i18n?.t('ai.cost_info.cost', {
    credits: toCredits(msgCost),
    defaultValue: `${toCredits(msgCost)} kredit`
  })
  const remainingLabel = showBudget
    ? i18n?.t('ai.cost_info.remaining', {
        remaining: toCredits(remaining),
        limit: toCredits(limit),
        defaultValue: `${toCredits(remaining)} / ${toCredits(limit)} kredit`
      })
    : null

  return (
    <div class={`ai-cost-badge d-flex align-items-center gap-3 mt-2 text-muted small${exceeded ? ' text-danger' : ''}`}>
      <span><i class="bi bi-coin me-1"></i>{costLabel}</span>
      {showBudget && (
        <span class={exceeded ? 'text-danger fw-semibold' : ''}>
          <i class="bi bi-pie-chart me-1"></i>{remainingLabel}
        </span>
      )}
      {exceeded && (
        <span class="badge bg-danger ms-1">
          {i18n?.t('ai.budget_exceeded.badge') || 'Kredit kimerült'}
        </span>
      )}
    </div>
  )
}
